<template>
  <div class="tabnavigationpanel">
    <div class="tabnavigationpanel__tabs"
         ref="viewport"
         @mousedown="viewportMouseDown"
         @mousemove="viewportMouseMove"
         @mouseup="viewportMouseUp">
      <router-link v-for="(tab, index) of tabs" 
                   :key="index"
                   :to="navigateTo(tab)"
                   custom
                   v-slot="{navigate, isExactActive}">
        <div :class="['tabnavigationpanel__tab', isExactActive && 'tabnavigationpanel__tab--active']"
             :style="(tab.override && isExactActive) && tab.overrideStyle"
             @click="navigate">
          <span>{{ tab.label }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab-navigation-panel',
  props: {
    tabs: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    pos: {
      top: 0, left: 0,
      x: 0, y: 0,
      active: false
    }
  }),
  mounted() {
    document.addEventListener('mouseup', () => {
      if (this.pos.active) {
        this.viewportMouseUp();
      }
    });
  },
  methods: {
    navigateTo(tab) {
      if (tab.name) {
        return { name: tab.name };
      }
      else if (tab.path) {
        return { path: tab.path };
      }
    },
    viewportMouseDown(e) {
      this.pos.left = this.$refs.viewport.scrollLeft;
      this.pos.top = this.$refs.viewport.scrollTop;
      this.pos.x = e.clientX;
      this.pos.y = e.clientY;
      this.pos.active = true;
      this.$refs.viewport.style.cursor = 'grabbing';
      this.$refs.viewport.style.userSelect = 'none';
    },
    viewportMouseMove(e) {
      if (!this.pos.active)
        return;

      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      this.$refs.viewport.scrollTop = this.pos.top - dy;
      this.$refs.viewport.scrollLeft = this.pos.left - dx;
    },
    viewportMouseUp() {
      this.$refs.viewport.style.cursor  = 'grab';
      this.$refs.viewport.style.removeProperty('user-select');
      this.pos.active = false;
    }
  }
}
</script>

<style lang="scss">
.tabnavigationpanel {
  background-color: $black;
  height: 48px;
  // max-width: calc(100vw - 17px);

  .tabnavigationpanel__tabs {
    padding: 5px 12px 0 12px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: stretch;
    gap: 3px;
    font-size: .75em;
    font-weight: 500;
    height: 100%;
    width: 100vw;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
      
    .tabnavigationpanel__tab {
      background-color: $input-border;
      color: $panel;
      padding-left: 20px;
      padding-right: 20px;
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-evenly;
      max-width: 10%;
      min-width: 140px;
      transition: color .25s ease-out 0s, background-color .25s ease-out 0s, box-shadow .25s ease-out 0s;
      cursor: pointer;
      box-shadow: inset 3px -15px 20px -15px rgba(0, 0, 0, 0.25);
      -webkit-box-shadow: inset 3px -15px 20px -15px rgba(0, 0, 0, 0.25);

      &.tabnavigationpanel__tab--active {
        transition-duration: 0s;
        background-color: $panel;
        color: $black;
        box-shadow: none;
        -webkit-box-shadow: none;
      }
    }
  }
}
</style>
